/* bambusa-panier.js
   Regroupement des scripts maison qui etaient inline dans la section en-tete.
   Charge une seule fois en defer depuis layout/theme.liquid.
   Chaque bloc garde sa garde window.__x et son propre init : l'ordre et le
   comportement sont identiques a la version inline, mais le parseur HTML
   n'est plus interrompu avant l'image du hero.
   Pose le 2026-08-17. Ne pas remettre ces blocs dans les snippets.
*/

/* ---------- pastille du logo au defilement (ex snippets/header-logo-block.liquid) ---------- */
(function(){
  if (window.__bambusaPastilleInit) return;
  window.__bambusaPastilleInit = true;
  var root = document.documentElement;
  function onScroll(){
    var y = window.pageYOffset || root.scrollTop || 0;
    if (y > 8) { root.classList.add('bambusa-scrolled'); } else { root.classList.remove('bambusa-scrolled'); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ---------- barre de franco de port (ex snippets/free-shipping-bar.liquid) ---------- */
(function(){
  if (window.__bambusaFSB) return; window.__bambusaFSB = true;

  function fmt(cents){
    try { return (cents/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'}); }
    catch(e){ return (cents/100).toFixed(2).replace('.',',') + ' €'; }
  }

  function render(cents){
    document.querySelectorAll('[data-free-shipping-bar]').forEach(function(bar){
      var threshold = parseInt(bar.getAttribute('data-threshold'),10) || 50000;
      var msg = bar.querySelector('[data-fsb-msg]');
      var fill = bar.querySelector('[data-fsb-fill]');
      if (cents <= 0){ bar.setAttribute('hidden',''); return; }
      bar.removeAttribute('hidden');
      var remaining = threshold - cents;
      var pct = Math.max(0, Math.min(100, (cents/threshold)*100));
      if (remaining <= 0){
        msg.classList.add('is-complete');
        msg.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="width:1.05em;height:1.05em;vertical-align:-.16em;display:inline-block"><g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round"><path d="M4.4 20.6 8.9 8.4l6.7 6.7Z"/><path d="M8.9 8.4c2.4-.6 4.8.3 6.7 2.2s2.8 4.3 2.2 6.7"/><path d="M15.8 4.6V2.6M18.9 7.9l1.6-1.2M19.7 12.2l2 .3M17.2 5.4l1.4-1.4"/></g></svg> Vous bénéficiez de la <strong>livraison offerte</strong> !';
        fill.style.width = '100%';
      } else {
        msg.classList.remove('is-complete');
        msg.innerHTML = 'Plus que <strong>' + fmt(remaining) + '</strong> pour la livraison offerte <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" style="display:inline-block"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round"><path d="M6.4 6.4h9v10.4h-9"/><path d="M15.4 9.8h2.9l2.6 2.6.7.6v3.8h-2.4"/><circle cx="8.8" cy="17.4" r="1.8"/><circle cx="17.2" cy="17.4" r="1.8"/><path d="M10.6 16.8h4.8"/><path d="M15.4 12.6h3.4"/><path d="M2.4 9.8h4.4M2.4 11.6h3M2.4 13.4h1.6"/><path d="M6.4 16.8h.6"/></g></svg>';
        fill.style.width = pct + '%';
      }
    });
  }

  function currentCents(){
    var bar = document.querySelector('[data-free-shipping-bar]');
    return bar ? (parseInt(bar.getAttribute('data-current'),10) || 0) : 0;
  }

  var t;
  function refresh(){
    clearTimeout(t);
    t = setTimeout(function(){
      fetch('/cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(c){
          document.querySelectorAll('[data-free-shipping-bar]').forEach(function(b){
            b.setAttribute('data-current', c.total_price);
          });
          render(c.total_price);
        }).catch(function(){});
    }, 150);
  }

  function init(){
    render(currentCents());
    document.querySelectorAll('[data-subtotal]').forEach(function(node){
      new MutationObserver(refresh).observe(node, {childList:true, characterData:true, subtree:true});
    });
    ['cart:updated','cart:refresh','ajaxCart:afterCartLoad','cart:build'].forEach(function(ev){
      document.addEventListener(ev, refresh);
    });
  }

  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();

/* ---------- poubelle + quantite mini du panier (ex snippets/bmb-cart-trash.liquid) ---------- */
  (function () {
    if (window.bmbCartTrashInit) { return; }
    window.bmbCartTrashInit = true;

    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) { return; }
      var button = event.target.closest('[data-bmb-cart-remove]');
      if (!button) { return; }

      event.preventDefault();

      var item = button.closest('.cart__item');
      if (!item) { return; }

      var link = item.querySelector('[data-bmb-remove-link]');
      if (link) { link.click(); }
    });

    /* Lecture des minimums — le tiroir et la page panier peuvent tous deux
       avoir leur bloc JSON, on les fusionne à la volée. */
    function readMap(){
      var merged = {};
      var blocks = document.querySelectorAll('[data-bb-cart-min]');
      for (var i = 0; i < blocks.length; i++) {
        var map;
        try { map = JSON.parse(blocks[i].textContent); } catch (e) { continue; }
        if (!map) { continue; }
        for (var k in map) { if (!merged[k]) { merged[k] = map[k]; } }
      }
      return merged;
    }

    function minFor(key){
      if (!key) { return 1; }
      var entry = readMap()[key];
      if (!entry) { return 1; }
      var m = parseInt(entry.m, 10);
      return (isNaN(m) || m < 2) ? 1 : m;
    }

    /* --- 2) le client ne peut pas descendre sous le minimum --- */
    document.addEventListener('change', function (event) {
      var el = event.target;
      if (!el || !el.classList || !el.classList.contains('js-qty__num')) { return; }
      if (el.name !== 'updates[]') { return; }

      var min = minFor(el.getAttribute('data-id'));
      if (min < 2) { return; }

      var n = parseInt(el.value, 10);
      if (isNaN(n)) { return; }
      /* 0 = suppression de la ligne, on laisse passer */
      if (n > 0 && n < min) { el.value = min; }
    }, true);

    /* --- 3) rattrapage des lignes héritées d'avant la bascule --- */
    function notice(){
      var first = document.querySelector('.cart__item');
      if (!first || !first.parentNode) { return; }
      if (document.querySelector('.bb-qmin-notice')) { return; }
      var p = document.createElement('div');
      p.className = 'bb-qmin-notice';
      p.textContent = 'Les cannes sont vendues à partir d’une quantité minimum : la quantité de certaines lignes a été ajustée.';
      first.parentNode.insertBefore(p, first);
    }

    function autoFix(){
      var map = readMap();
      var updates = {};
      var count = 0;

      for (var k in map) {
        var m = parseInt(map[k].m, 10);
        var q = parseInt(map[k].q, 10);
        if (!isNaN(m) && !isNaN(q) && m > 1 && q > 0 && q < m) { updates[k] = m; count++; }
      }
      if (!count) { return; }

      /* anti-boucle : on ne retente jamais la même correction */
      var sig = JSON.stringify(updates);
      try {
        if (sessionStorage.getItem('bbQminSig') === sig) { return; }
        sessionStorage.setItem('bbQminSig', sig);
      } catch (e) {}

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        if (location.pathname.indexOf('/cart') === 0) {
          try { sessionStorage.setItem('bbQminNotice', '1'); } catch (e) {}
          location.reload();
        }
      });
    }

    function start(){
      try {
        if (sessionStorage.getItem('bbQminNotice')) {
          sessionStorage.removeItem('bbQminNotice');
          notice();
        }
      } catch (e) {}
      autoFix();
    }

    if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
    else { start(); }
  })();

/* ---------- upsell du panier (ex snippets/cart-upsell.liquid) ---------- */
(function(){
  if (window.__bambusaUpsell) return; window.__bambusaUpsell = true;

  function root(){
    var el = document.querySelector('[data-cart-upsell]');
    return (el && el.getAttribute('data-root')) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function fmt(cents){
    try { return (cents/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' €'; }
    catch(e){ return (cents/100).toFixed(2).replace('.',',') + ' €'; }
  }

  function fetchReco(productId, intent){
    var url = root() + 'recommendations/products.json?product_id=' + productId + '&intent=' + intent + '&limit=8';
    return fetch(url, {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .then(function(d){ return (d && d.products) || []; })
      .catch(function(){ return []; });
  }

  function collectRecos(cart){
    var inCart = {};
    var productIds = [];
    (cart.items || []).forEach(function(it){
      inCart[it.product_id] = true;
      if (productIds.indexOf(it.product_id) === -1) productIds.push(it.product_id);
    });
    if (!productIds.length) return Promise.resolve([]);

    var cfg = document.querySelector('[data-cart-upsell]');
    var fallback = cfg ? cfg.getAttribute('data-fallback') : 'related';

    // 1) complémentaires configurés dans Search & Discovery
    return Promise.all(productIds.map(function(id){ return fetchReco(id, 'complementary'); }))
      .then(function(lists){
        var picked = dedupe(lists, inCart);
        if (picked.length) return picked;
        // 2) repli : produits liés
        if (fallback === 'related'){
          return Promise.all(productIds.map(function(id){ return fetchReco(id, 'related'); }))
            .then(function(rlists){ return dedupe(rlists, inCart); });
        }
        return [];
      });
  }

  function dedupe(lists, inCart){
    var seen = {}, out = [];
    lists.forEach(function(list){
      list.forEach(function(p){
        if (inCart[p.id] || seen[p.id]) return;
        seen[p.id] = true;
        out.push(p);
      });
    });
    return out;
  }

  function firstVariant(p){
    var v = (p.variants || []).filter(function(x){ return x.available; })[0] || (p.variants || [])[0];
    return v || null;
  }

  function card(p){
    var v = firstVariant(p);
    var img = p.featured_image || (p.images && p.images[0]) || '';
    // Bambusa : la vignette fait 150 a 200 px de large ; on demande au CDN Shopify
    // une version 400 px (retina) au lieu de l'original 2048 px.
    if (img) { img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400'; }
    var el = document.createElement('div');
    el.className = 'cart-upsell__card';
    var priceCents = (typeof p.price === 'number') ? p.price : (p.price_min || 0);
    el.innerHTML =
      '<a class="cart-upsell__imgwrap" href="' + (p.url || '#') + '">' +
        (img ? '<img loading="lazy" width="400" height="400" src="' + img + '" alt="' + (p.title||'').replace(/"/g,'&quot;') + '">' : '') +
      '</a>' +
      '<div class="cart-upsell__info">' +
        '<a class="cart-upsell__name" href="' + (p.url || '#') + '">' + (p.title || '') + '</a>' +
        '<span class="cart-upsell__price">' + fmt(priceCents) + '</span>' +
        (v ? '<button type="button" class="cart-upsell__btn" data-add="' + v.id + '">+ Ajouter</button>'
           : '<a class="cart-upsell__btn" style="text-align:center;text-decoration:none;" href="' + (p.url||'#') + '">Voir</a>') +
      '</div>';
    return el;
  }

  function addToCart(variantId, btn){
    btn.setAttribute('disabled','');
    btn.textContent = 'Ajout…';
    fetch(root() + 'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: variantId, quantity: 1 }] })
    })
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){
      btn.innerHTML = 'Ajouté <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="width:1.05em;height:1.05em;vertical-align:-.16em;display:inline-block"><g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round"><path d="M4.4 12.6c1.8 1.4 3.4 3.1 4.8 5 3-4.6 6.4-8.5 10.4-11.8"/></g></svg>';
      var onCartPage = /\/cart(\/|$|\?|#)/.test(window.location.pathname + window.location.search);
      if (onCartPage){
        // page panier = liste rendue serveur : recharge pour voir la nouvelle ligne
        setTimeout(function(){ window.location.reload(); }, 300);
      } else {
        // tiroir Impulse : reconstruit + ouvre sans recharger (événements Archetype)
        try { document.dispatchEvent(new CustomEvent('cart:build')); } catch(e){}
        try { document.dispatchEvent(new CustomEvent('cart:open')); } catch(e){}
        setTimeout(function(){ btn.removeAttribute('disabled'); btn.textContent = '+ Ajouter'; }, 1400);
      }
    })
    .catch(function(){
      btn.removeAttribute('disabled');
      btn.textContent = 'Réessayer';
    });
  }

  function paint(recos){
    var containers = document.querySelectorAll('[data-cart-upsell]');
    containers.forEach(function(box){
      var track = box.querySelector('[data-cart-upsell-track]');
      var limit = parseInt(box.getAttribute('data-limit'),10) || 4;
      if (!track) return;
      track.innerHTML = '';
      var list = recos.slice(0, limit);
      if (!list.length){ box.setAttribute('hidden',''); return; }
      list.forEach(function(p){ track.appendChild(card(p)); });
      box.removeAttribute('hidden');
    });
  }

  var busy = false, t;
  function refresh(){
    clearTimeout(t);
    t = setTimeout(function(){
      if (busy) return; busy = true;
      fetch(root() + 'cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          if (!cart.items || !cart.items.length){ paint([]); busy=false; return; }
          collectRecos(cart).then(function(recos){ paint(recos); busy=false; });
        })
        .catch(function(){ busy=false; });
    }, 150);
  }

  function init(){
    // délégation du clic « Ajouter »
    document.addEventListener('click', function(e){
      var btn = e.target.closest && e.target.closest('.cart-upsell__btn[data-add]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn.getAttribute('data-add'), btn);
    });
    // ré-affiche quand le panier change
    document.querySelectorAll('[data-subtotal]').forEach(function(node){
      new MutationObserver(refresh).observe(node, {childList:true, characterData:true, subtree:true});
    });
    ['cart:updated','cart:refresh','ajaxCart:afterCartLoad','cart:build'].forEach(function(ev){
      document.addEventListener(ev, refresh);
    });
    refresh();
  }

  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();

/* ---------- Option Serenite dans le panier (ex snippets/serenite-cart.liquid) ---------- */
(function(){
  if (window.__bambusaSereniteCart) return; window.__bambusaSereniteCart = true;

  var HANDLE    = 'serenite-plantation-1-an';
  var THRESHOLD = 5000;
  var ROOT      = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, timer = null;

  function getCart(){
    return fetch(ROOT + 'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
  }

  /* Vide les marqueurs de garantie sans toucher aux autres propriétés.
     Valeur vide obligatoire : Shopify ignore un objet properties vide. */
  function clearedProps(props){
    var out = {};
    Object.keys(props || {}).forEach(function(k){ out[k] = props[k]; });
    out['_sp_key'] = '';
    out['Sérénité Plantation'] = '';
    return out;
  }

  function onCartPage(){
    return /\/cart(\/|$|\?|#)/.test(window.location.pathname + window.location.search);
  }
  function done(changed){
    busy = false;
    if (!changed) return;
    if (onCartPage()) { window.location.reload(); return; }
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch(e){}
  }

  function pass(depth, changed){
    if (depth > 6) { done(changed); return; }

    getCart().then(function(cart){
      var plants = {}, guarantees = [];
      (cart.items || []).forEach(function(it){
        var k = it.properties && it.properties._sp_key;
        if (!k) return;
        if (it.handle === HANDLE) guarantees.push(it); else plants[k] = it;
      });

      if (!guarantees.length && !Object.keys(plants).length) { done(changed); return; }

      var updates = {}, needUpdate = false, orphans = [], kept = {};

      guarantees.forEach(function(g){
        var k = g.properties._sp_key;
        var p = plants[k];
        if (!p)                            { updates[g.key] = 0; needUpdate = true; return; }
        if (p.final_line_price < THRESHOLD){ updates[g.key] = 0; needUpdate = true; return; }
        kept[k] = true;
        if (g.quantity !== p.quantity)     { updates[g.key] = p.quantity; needUpdate = true; }
      });

      Object.keys(plants).forEach(function(k){
        if (!kept[k]) orphans.push(plants[k]);
      });

      if (needUpdate){
        fetch(ROOT + 'cart/update.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({updates: updates})
        }).then(function(){ pass(depth+1, true); }).catch(function(){ done(changed); });
        return;
      }

      if (orphans.length){
        var p = orphans[0];
        fetch(ROOT + 'cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({id: p.key, quantity: p.quantity, properties: clearedProps(p.properties)})
        }).then(function(){ pass(depth+1, true); }).catch(function(){ done(changed); });
        return;
      }

      done(changed);
    }).catch(function(){ busy = false; });
  }

  function check(){
    clearTimeout(timer);
    timer = setTimeout(function(){
      if (busy) return;
      busy = true;
      pass(0, false);
    }, 250);
  }

  /* --- ajout de la garantie depuis le panier ------------------------------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-sp-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var lineKey = btn.getAttribute('data-key');
    var qty     = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    var variant = btn.getAttribute('data-variant');
    var label   = btn.getAttribute('data-label') || '';
    var ref     = btn.getAttribute('data-ref') || '';
    var span    = btn.querySelector('span');
    var was     = span ? span.textContent : '';

    btn.disabled = true;
    if (span) span.textContent = 'Ajout…';

    var key = 'sp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,6);

    getCart().then(function(cart){
      var line = (cart.items || []).filter(function(i){ return i.key === lineKey; })[0];
      var props = {};
      Object.keys((line && line.properties) || {}).forEach(function(k){ props[k] = line.properties[k]; });
      props['Sérénité Plantation'] = 'Oui — garantie 1 an';
      props['_sp_key'] = key;

      return fetch(ROOT + 'cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: lineKey, quantity: qty, properties: props})
      });
    })
    .then(function(r){ if(!r.ok) throw new Error('change'); return r.json(); })
    .then(function(){
      var optProps = {};
      optProps['Végétal couvert'] = label;
      optProps['_sp_key'] = key;
      optProps['_sp_prix_ref'] = ref;
      return fetch(ROOT + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id: variant, quantity: qty, properties: optProps}]})
      });
    })
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){
      if (onCartPage()) { window.location.reload(); return; }
      try { document.dispatchEvent(new CustomEvent('cart:build')); } catch(e){}
      btn.disabled = false;
      if (span) span.textContent = was;
    })
    .catch(function(){
      btn.disabled = false;
      if (span) span.textContent = 'Réessayer';
    });
  });

  function init(){
    document.querySelectorAll('[data-subtotal]').forEach(function(node){
      new MutationObserver(check).observe(node, {childList:true, characterData:true, subtree:true});
    });
    ['cart:updated','cart:refresh','ajaxCart:afterCartLoad','cart:build'].forEach(function(ev){
      document.addEventListener(ev, check);
    });
    check();
  }

  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
